import { SILENT_PROBE_SRC } from './silentProbeSrc';
function disposeAudio(audio) {
    try {
        audio.pause();
    }
    catch {
        // ignore
    }
    audio.removeAttribute('src');
    try {
        audio.load();
    }
    catch {
        // ignore
    }
}
/**
 * 무음(또는 비가청) 오디오를 `muted` 없이 `play()` 해 사운드 자동재생 가능 여부를 판별한다.
 *
 * - 성공 → unlocked 후보 (스트랩 숨김)
 * - 실패(`NotAllowedError` 등) → 제스처 필요 (스트랩)
 * - `muted=true`로 프로브하지 않는다 (오탐)
 *
 * Chromium 73: `navigator.getAutoplayPolicy` 미사용.
 */
export async function probeUnmutedAutoplay(options = {}) {
    const AudioCtor = options.AudioCtor ?? globalThis.Audio;
    if (typeof AudioCtor !== 'function') {
        return { ok: false, error: new Error('Audio constructor unavailable') };
    }
    const audio = new AudioCtor();
    audio.preload = 'auto';
    // 정책: unmuted 재생 시도. volume은 파일이 무음이므로 청각 영향 없음.
    audio.muted = false;
    audio.volume = 1;
    audio.src = options.src ?? SILENT_PROBE_SRC;
    try {
        const playResult = audio.play();
        if (playResult !== undefined && typeof playResult.then === 'function') {
            await playResult;
        }
        disposeAudio(audio);
        return { ok: true };
    }
    catch (error) {
        disposeAudio(audio);
        return { ok: false, error };
    }
}
//# sourceMappingURL=probeUnmutedAutoplay.js.map